import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Stack,
  CircularProgress,
  Alert,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

/**
 * ReplyEditor Component
 * Rich text editor for admins to reply to support tickets
 * Uses Quill for HTML formatting
 */
export function ReplyEditor({ ticketId, onSubmit, loading = false, disabled = false }) {
  const [content, setContent] = useState('');
  const [error, setError] = useState('');

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      ['link'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'code-block',
    'list',
    'bullet',
    'indent',
    'script',
    'link',
  ];

  const handleSubmit = async () => {
    // Trim HTML to check if it's actually empty
    const trimmedContent = content.replace(/<[^>]*>/g, '').trim();

    if (!trimmedContent) {
      setError('Resposta não pode estar vazia');
      return;
    }

    try {
      setError('');
      await onSubmit({
        content: content,
      });
      setContent(''); // Clear editor on success
    } catch (err) {
      setError(err.message || 'Erro ao enviar resposta');
    }
  };

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Stack spacing={2}>
          <Box>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
              Sua Resposta
            </label>
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              modules={modules}
              formats={formats}
              readOnly={disabled}
              style={{
                minHeight: '150px',
                backgroundColor: disabled ? '#f5f5f5' : 'white',
              }}
            />
          </Box>

          {error && <Alert severity="error">{error}</Alert>}

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="contained"
              endIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
              onClick={handleSubmit}
              disabled={loading || disabled || !content.trim()}
            >
              {loading ? 'Enviando...' : 'Enviar Resposta'}
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default ReplyEditor;
